// 快递存，扫描快递条码
<template>
  <div class="scanExpressCode">
    <!-- 流程 -->
    <expressSaveFlow :index="4"></expressSaveFlow>
    <p class="title">在柜子下方扫描快递单条码</p>
    <div class="list clearfix">
      <div class="left-bracket"></div>
      <p class="code">快递单条码</p>
      <div class="right-bracket"></div>
    </div>

    <!-- 上一步 -->
    <span class="turnoverCabinet-btn-back" v-show="$store.state.isShowRBot" @click="back">上一步</span>
    <!-- mqtt -->
    <mqttws ref="mqttws" @getMessage="getMessage"></mqttws> 
  </div>
</template>

<script>
import mqttws from '../../../assets/mqttws2'
import expressSaveFlow from '../expressSave/expressSaveFlow'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showToast, storage } from '../../../../static/turnoverCabinet/js/utility'

let timeout
export default {
  name: 'scanExpressCode',
  components: {
    expressSaveFlow,
    mqttws
  },
  data () {
    return {
      cardNum: ''
    }
  },
  created () {
    console.log('type', this.$store.state.type)
    // this.getExpressNumber()
  },
  mounted () {
  },
  // 页面销毁后
  destroyed () {
    // 停止轮询
    clearTimeout(timeout)
  },
  watch: {
    // 监听socketData，数据返回（卡号、快递单号、二维码验证结果）
    '$store.state.socketData': function (newVal) {
      console.log('newVal', newVal)
      if (newVal !== '') {
        this.processSocketData(newVal)
      }
    }
  },
  methods: {
    // 获取mqtt信息
    getMessage(res){
      console.log('mqtt返回信息',res)
      let vm = this
      // type信息类型：identityCheck为身份认证， Exp为扫描快递单号
      if (res.type === 'Exp') {
        if (res.meta.code === 200) {
        console.log('获取快递单号成功', res)
        // 确认投递参数 --- 快递单号
        this.$store.state.deliverData.t_package_no = res.data.t_package_no
        this.goSaveFinish()
      } else {
          showToast(res.meta.message)
        }
      }
    },
    // 轮询查询快递单号
    async getExpressNumber () {
      let vm= this
      let data = {
        device_no_id: storage.localGetItem('device_no_id')
      }

      let res = await cabinetApi.getExpressNumber(data)
      if (res.meta.code === 200) {
        console.log('获取快递单号成功', res)
        // 确认投递参数 --- 快递单号
        this.$store.state.deliverData.t_package_no = res.data.t_package_no
        this.goSaveFinish()
      } else {
        console.log('未验证')
        timeout = setTimeout(() => {
          vm.getExpressNumber()
        }, 500)
      }
    },
    // 跳转到存件完成页面
    goSaveFinish: function () {
      this.$router.push({
        // 你要跳转的地址
        path: '/turnoverCabinet/saveFinish'
      })
    },
    // 返回上一页  （输入取件人手机）
    back () {
      this.$router.push('/turnoverCabinet/importPhone')
    }
  }
}
</script>

<style scoped>
.scanExpressCode{
  width: 100%;
  text-align: center;
}

.scanExpressCode .title{
  font-size: 0.45rem;
  line-height: 0.55rem;
  margin: 0.85rem 0 0.35rem;
}

.scanExpressCode .list{
  margin: 0 auto;
  width: 7.64rem;
}

.scanExpressCode .list .left-bracket,
.scanExpressCode .list .right-bracket{
  float: left;
  width: 0.54rem;
  height: 4.85rem;
  border: 0.04rem solid #ffffff;
}

.scanExpressCode .list .left-bracket{
  border-right: none;
}

.scanExpressCode .list .right-bracket{
  border-left: none;
}

.scanExpressCode .list .code{
  width: 5.75rem;
  float: left;
  height: 3.52rem;
  line-height: 3.52rem;
  font-size: 0.34rem;
  margin: 0.66rem 0.405rem 0;
  border: 1px solid #797979;
  border-radius: 10px;
  background-color: #efefef;
}

.btn-cancel{
  display: block;
  width: 110px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: #333333;
  border-radius: 5px;
  background-color: #999999;
  position: absolute;
  right: 30px;
  bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/expressSave/scanExpressCode.vue